import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase/config';
import dayjs from 'dayjs';

export const updatePostnatalPhaseIfPossible = async (uid: string) => {
  try {
    const userRef = doc(db, 'users', uid); // ← was 'profiles'
    const userSnap = await getDoc(userRef);

    if (userSnap.exists()) {
      const userData = userSnap.data();
      if (userData.delivery_date) {
        const deliveryDate = dayjs(userData.delivery_date);
        if (!deliveryDate.isValid()) return;
        const now = dayjs();
        const diffInDays = now.diff(deliveryDate, 'day');

        let postnatal_phase = 'beyond_8_weeks';
        if (diffInDays <= 56) {
          postnatal_phase = 'early_6_8_weeks';
        }

        await updateDoc(userRef, { postnatal_phase });
      }
    }
  } catch (err) {
    console.error('updatePostnatalPhaseIfPossible failed:', err);
  }
};